import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../services/authContext';
import './Navigation.css';

const Navigation = () => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-brand">
          <h1 onClick={() => navigate('/')}>Aplikasi Arisan</h1>
        </div>
        {user && (
          <div className="navbar-menu">
            <ul>
              <li><a href="/" onClick={() => navigate('/')}>Beranda</a></li>
              <li><a href="/arisans" onClick={() => navigate('/arisans')}>Arisan</a></li>
              {user.role === 'admin' && (
                <li><a href="/admin/users" onClick={() => navigate('/admin/users')}>Kelola Pengguna</a></li>
              )}
              <li><a href="/profile" onClick={() => navigate('/profile')}>Profil</a></li>
              <li><button onClick={handleLogout} className="btn-logout">Keluar</button></li>
            </ul>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
